var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "select_opt_area" }, [
    _c("div", { staticClass: "desc_list" }, [
      _vm.lang === "KOR"
        ? _c("ul", [
            _c("li", [
              _vm._v(
                " UNNO 미부착 또는 수기(Handwritten) 시, 기항지에서 큰 액수의 벌금이 부과될 수 있으므로 선적 과정에서 발견될 경우, 통보없이 선적 거절될 수 있습니다. (FAQ 참조) "
              ),
            ]),
            _c("li", { staticClass: "color_red" }, [
              _vm._v(
                " CAS No. 제약이 있는 항만으로 수출입할 경우 MSDS에 기재된 모든 CAS No.를 누락없이 입력하셔야 하며 부정확한 정보 입력으로 인하여 발생하는 모든 책임은 신고자(송하인)에게 있음을 알려 드립니다. "
              ),
            ]),
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false",
                  },
                ],
                staticClass: "color_red",
              },
              [
                _vm._v(
                  " MSDS상 Secret CAS No. (MSDS상 CAS No.미공개로 표시됨)가 있는 경우, 별도로 확인하여 알려주시거나 제공이 불가한 경우, 책임이 신고자(송하인)에게 있음을 승인하는 LOI 제출 바랍니다. * 당사 공지사항 참조 "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm.lang !== "KOR"
        ? _c("ul", [
            _c("li", [
              _vm._v(
                " In case of missing UNNO or handwritten UNNO on the DG container can result in large amount of penalty at calling ports. If it is found before loading, it could be rejected without pre-notice. "
              ),
            ]),
            _c("li", [_vm._v(_vm._s(_vm.$t("msg.CSBK100.094")))]),
            _c("li", [_vm._v(_vm._s(_vm.$t("msg.CSBK100.095")))]),
            _c("li", [_vm._v(_vm._s(_vm.$t("msg.CSBK100.096")))]),
            _vm._m(0),
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false",
                  },
                ],
                staticClass: "color_red",
              },
              [
                _vm._v(
                  " If there are 'secret CAS numbers' which are unwritten CAS numbers, Please let us know directly. If It isn't possible to provide it, Please submit an LOI, confirming that all of the responsibilities rests with the shipper (Reporter). "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "color_red" }, [
      _vm._v(
        " All of CAS numbers shown on Chinese MSDS have to be entered on DG cargo details without omission When DG cargo is shipped to the restricted ports which force to provide CAS numbers."
      ),
      _c("br"),
      _vm._v(
        "Shipper (Reporter) should take all of the responsibilities caused by inaccurate information provided. "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }